import axios from '../config/axios'
import Instrument from '../models/Instrument'

export const findAll = () =>
  axios.get<Map<string, Instrument[]>>('api/market/instruments', {
    timeout: parseInt(process.env.REACT_APP_SLOW_API_TIMEOUT || '10000'),
  })

export default { findAll }
